import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="font-heading text-xl font-bold tracking-wide whitespace-nowrap text-background-50">
              爱威奶
            </Link>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              呵护每一刻，品质新选择。<br />用科学与自然的力量，守护您和家人的健康。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
              产品系列
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/children" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">儿童系列</Link>
              <Link to="/category/adult" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">成人系列</Link>
              <Link to="/category/senior" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">中老年系列</Link>
              <Link to="/category/sport" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">运动营养</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
              帮助中心
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/guide" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">使用指南</Link>
              <Link to="/category/review" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">用户评测</Link>
              <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <a href="#faq" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
              联系方式
            </h4>
            <div className="flex flex-col gap-2 text-sm text-secondary-300">
              <p className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-9999</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>service@aiweinai.com</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>周一至周日 9:00-21:00</span>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 爱威奶 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}